import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import { PayDetail, PayDetailType, SearchQuoteOrderLine } from '../../models/models';

@Component({
    selector: 'pay-detail-form',
    templateUrl: './pay-detail-form.component.html',
    standalone: false
})
export class PayDetailForm implements OnChanges, OnInit {
    @Input() payDetail: PayDetail = {} as PayDetail;
    @Input() pageType: string = "";
    @Output() onRefresh = new EventEmitter<any>();

    //public quoteOrder: QuoteOrder = {} as QuoteOrder;
    public payDetailTypeList: PayDetailType[] = [];
    public line: SearchQuoteOrderLine = {} as SearchQuoteOrderLine;
    public quoteOrderLineList: SearchQuoteOrderLine[] = [];
    public isAccounting: boolean = false;
    public isLoading: boolean = false;

    constructor(private orderService: OrderService,
        private notificationService: NotificationService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.isAccounting = this.getIsAccounting();

        this.orderService.getPayDetailTypes().subscribe(result => {
            this.payDetailTypeList = result;
            this.payDetailTypeList = this.payDetailTypeList.filter(t => t.thirdParty != true);
            this.payDetailTypeList = this.payDetailTypeList.sort((left, right): number => {
                if (left.abbrev < right.abbrev) return -1;
                if (left.abbrev > right.abbrev) return 1;
                return 0;
            });
        });
        this.orderService.getSearchQuoteOrderLineByID(this.payDetail.quoteOrderLineId).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.line = result.resultCollection[0];
                this.orderService.getSearchQuoteOrderLinesByQuoteOrderID(this.line.quoteOrderID).subscribe(result2 => {
                    this.quoteOrderLineList = result2.resultCollection;
                    this.quoteOrderLineList = this.quoteOrderLineList.filter(t => t.carrierID > 0);
                    this.setLoadNumber(this.payDetail.quoteOrderLineId);
                });
            }
        });
        //console.log("ngOnInit", this.payDetail);
    }

    ngOnChanges() {
        //console.log("ngOnChanges", this.payDetail);
    }

    private getIsAccounting() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('Accounting') > -1) return true;
        }

        return false;
    }

    public calcAmount() {
        if (!isNaN(this.payDetail.quantity) && !isNaN(this.payDetail.rate)) {
            this.payDetail.rate = Math.round((this.payDetail.rate + Number.EPSILON) * 100) / 100;
            this.payDetail.amount = this.payDetail.quantity * this.payDetail.rate;
            this.payDetail.amount = Math.round((this.payDetail.amount + Number.EPSILON) * 100) / 100;
        }
    }

    public setLoadNumber(lineID: number) {
        var line: SearchQuoteOrderLine = this.quoteOrderLineList.find(q => q.quoteOrderLineID == lineID) as SearchQuoteOrderLine;
        this.payDetail.assignToId = line.carrierID;
        this.payDetail.payToId = line.carrierID;
        if (this.payDetail.payDetailTypeId > 0) {
            var payDetailType: PayDetailType = this.payDetailTypeList.find(t => t.payDetailTypeId == this.payDetail.payDetailTypeId)!;
            this.payDetail.erpItemCode = payDetailType.erpCode;
        }
    }

    public isValid() {
        var valid: boolean = true;
        if (this.payDetail.quoteOrderLineId == 0) {
            valid = false;
        }
        if (this.payDetail.payDetailTypeId == 0) {
            valid = false;
        }
        if (this.payDetail.quantity == 0 || this.payDetail.quantity == null) {
            valid = false;
        }
        if (this.payDetail.rate == 0 || this.payDetail.rate == null) {
            valid = false;
        }
        return valid;
    }

    public save() {
        this.isLoading = true;
        console.log("save", this.payDetail);
        this.setLoadNumber(this.payDetail.quoteOrderLineId);
        this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Pay Detail Form Save");
        this.orderService.savePayDetail(this.payDetail).subscribe(result => {
            this.isLoading = false;
            if (result.payDetailId > 0) {
                //this.getCustomers();
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
            }
        });

        this.payDetail = {} as PayDetail;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
